import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/faq/[category]/[subcategory]/FAQSubCategory.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/BereavmentCategoryActive.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/BereavmentCategoryIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/CarValueTrackerActive.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/CarValueTrackerCategory.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/CollectionIconCategory.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/CollectionIconCategoryActive.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/DocumentsIconCategory.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/DocumentsIconCategoryActive.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/PaymentCategory.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/PaymentIconCategoryActive.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/ProfilingIconCategory.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/ProfilingIconCategoryActive.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/SellingIconCategory.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/faqCategory/SellingIconCategoryActive.svg");
